import axios from "axios";
import { baseURL } from "../config/api";

export const post_CustomerEnquiry = (data: any, tenantId: string) => {
    return axios({
        url: `${baseURL}customerEnquiry`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}